var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Chart from "@/components/widgets/chart/chart";
export var ReportsChartItem = function (_a) {
    var _b = _a.chartData, chartData = _b === void 0 ? {} : _b, _c = _a.chartType, chartType = _c === void 0 ? "bar" : _c;
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "relative mr-2" }, { children: _jsx(_Fragment, { children: _jsx(Chart, { chartData: chartData, chartType: chartType, symbol: ["", ""] }) }) })) }));
};
